import {
  Directive,
  EventEmitter,
  Input,
  OnChanges,
  Output,
} from '@angular/core';

@Directive({
    selector: '[luiTopIconCardIcon]',
    standalone: false
})
export class TopIconCardIconDirective {}

@Directive({
    selector: '[luiTopIconCardHeader]',
    standalone: false
})
export class TopIconCardHeaderDirective {}

@Directive({
    selector: '[luiTopIconCardBody]',
    standalone: false
})
export class TopIconCardBodyDirective implements OnChanges {
  @Input() opened = true;
  @Input() additionalClass!: string;
  @Output() openedChanged = new EventEmitter();

  ngOnChanges(): void {
    this.openedChanged.emit(this.opened);
  }
}

@Directive({
    selector: '[luiTopIconCardFooter]',
    standalone: false
})
export class TopIconCardFooterDirective {}
